declare global {
  interface Window {
    nuanceRevealFallback?: number | null
  }
}

const burger = document.querySelector<HTMLButtonElement>('.nav__burger')
const drawer = document.getElementById('mobile-nav')

if (burger && drawer) {
  burger.addEventListener('click', () => {
    const open = drawer.classList.toggle('is-open')
    burger.setAttribute('aria-expanded', open ? 'true' : 'false')
  })
}

// CSS handles hover on pointer devices. This covers click, touch, and keyboard.
const dropdowns = document.querySelectorAll<HTMLElement>('[data-dropdown]')

function closeAll(except: HTMLElement | null) {
  dropdowns.forEach((dropdown) => {
    if (dropdown === except) return

    dropdown.classList.remove('is-open')
    dropdown.querySelector('.nav__trigger')?.setAttribute('aria-expanded', 'false')
  })
}

dropdowns.forEach((dropdown) => {
  const trigger = dropdown.querySelector<HTMLButtonElement>('.nav__trigger')
  if (!trigger) return

  trigger.addEventListener('click', (event) => {
    event.stopPropagation()
    const open = dropdown.classList.toggle('is-open')
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
    closeAll(dropdown)
  })

  dropdown.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !dropdown.classList.contains('is-open')) return

    dropdown.classList.remove('is-open')
    trigger.setAttribute('aria-expanded', 'false')
    trigger.focus()
  })
})

document.addEventListener('click', () => closeAll(null))

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
const reveals = document.querySelectorAll<HTMLElement>('.reveal')

if (reducedMotion || !('IntersectionObserver' in window)) {
  reveals.forEach((element) => element.classList.add('in'))
} else {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      entry.target.classList.add('in')
      observer.unobserve(entry.target)
    })
  }, { threshold: 0, rootMargin: '0px 0px -6% 0px' })

  reveals.forEach((element) => observer.observe(element))
}

if (window.nuanceRevealFallback !== null) {
  window.clearTimeout(window.nuanceRevealFallback)
}
window.nuanceRevealFallback = null

if (location.hash) {
  const target = document.getElementById(location.hash.slice(1))
  if (target && document.fonts) {
    let correctionCancelled = false
    const intentEvents = ['wheel', 'touchstart', 'keydown'] as const
    const cancelCorrection = () => { correctionCancelled = true }

    intentEvents.forEach((eventName) => window.addEventListener(eventName, cancelCorrection, { once: true }))
    document.fonts.ready.then(() => {
      intentEvents.forEach((eventName) => window.removeEventListener(eventName, cancelCorrection))
      if (correctionCancelled) return

      const navHeight = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 0
      const top = target.getBoundingClientRect().top + window.scrollY - navHeight - 24
      window.scrollTo({ top, behavior: 'instant' })
    })
  }
}

const form = document.querySelector<HTMLFormElement>('#contact-form')
const card = document.getElementById('form-card')
const errorElement = document.getElementById('form-error')
const button = form?.querySelector<HTMLButtonElement>('button[type=submit]')

if (form && card && errorElement && button) {
  const emailInput = form.elements.namedItem('email')
  const originalLabel = button.textContent || ''
  let frozenBody: FormData | null = null

  form.addEventListener('submit', (event) => {
    event.preventDefault()
    card.classList.remove('is-errored')

    const email = emailInput instanceof HTMLInputElement ? emailInput.value.trim() : ''
    if (!email) {
      errorElement.textContent = 'An email address is the one thing we need to reply.'
      card.classList.add('is-errored')
      return
    }

    const fields = form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input:not([type=hidden]), textarea')
    const selects = form.querySelectorAll<HTMLSelectElement>('select')
    const controller = 'AbortController' in window ? new AbortController() : null
    const timeout = controller ? window.setTimeout(() => controller.abort(), 12000) : null
    frozenBody ||= new FormData(form)
    fields.forEach((field) => { field.readOnly = true })
    selects.forEach((field) => { field.disabled = true })
    button.disabled = true
    button.textContent = 'Sending…'

    const token = document.querySelector<HTMLMetaElement>('meta[name=csrf-token]')
    const request: RequestInit = {
      method: 'POST',
      headers: {
        'X-CSRF-Token': token?.content || '',
        Accept: 'application/json',
      },
      body: frozenBody,
    }
    if (controller) request.signal = controller.signal

    fetch(form.action, request).then((response) => {
      if (response.ok) {
        card.classList.add('is-sent')
        return
      }

      return response.json().catch(() => ({})).then((data: { errors?: string[] }) => {
        errorElement.textContent = data.errors?.[0]
          || "That didn't send. Please try again, or email ashutosh@tinkerlab.co.uk directly."
        card.classList.add('is-errored')
        fields.forEach((field) => { field.readOnly = false })
        selects.forEach((field) => { field.disabled = false })
        frozenBody = null
        button.textContent = originalLabel
      })
    }).catch(() => {
      errorElement.textContent = "That didn't send. Your original note is frozen while you retry, or email ashutosh@tinkerlab.co.uk directly."
      card.classList.add('is-errored')
      button.textContent = 'Retry'
    }).finally(() => {
      if (timeout) window.clearTimeout(timeout)
      button.disabled = false
    })
  })
}

export {}
